import { render, staticRenderFns } from "./changePost.vue?vue&type=template&id=c0ef6302&scoped=true&"
import script from "./changePost.vue?vue&type=script&lang=js&"
export * from "./changePost.vue?vue&type=script&lang=js&"
import style0 from "./changePost.vue?vue&type=style&index=0&id=c0ef6302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ef6302",
  null
  
)

export default component.exports